import { useMemo, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { openRandomPlayLink, openPlayLinkByBrand, trackRegisterClickByBrand } from '../../config/playLinks';

interface FreeGameItem {
  id: string;
  name: string;
  provider: string;
  image: string;
  maxWin: string;
  rtp: string;
}

type ProviderName =
  | 'BNG'
  | 'CQ9'
  | 'JILI'
  | 'Joker'
  | 'JDB'
  | 'Rich Gaming'
  | 'Pragmatic Play'
  | 'Microgaming';

interface ProviderOption {
  value: 'All Providers' | ProviderName;
  label: string;
  logo: string;
}

const providerOptions: ProviderOption[] = [
  { value: 'All Providers', label: 'All', logo: '' },
  { value: 'BNG', label: 'Bng', logo: '/provider-logos/bng.png' },
  { value: 'CQ9', label: 'CQ9', logo: '/provider-logos/cq9.png' },
  { value: 'JILI', label: 'JILI', logo: '/provider-logos/jili.png' },
  { value: 'Joker', label: 'Joker', logo: '/provider-logos/joker.png' },
  { value: 'JDB', label: 'JDB', logo: '/provider-logos/jdb.png' },
  { value: 'Rich Gaming', label: 'Rich Gaming', logo: '/provider-logos/rich-gaming.png' },
  { value: 'Pragmatic Play', label: 'Pragmatic Play', logo: '/provider-logos/pragmatic-play.png' },
  { value: 'Microgaming', label: 'Microgaming', logo: '/provider-logos/microgaming.png' },
];

const providerGameLibrary: Record<ProviderName, FreeGameItem[]> = {
  BNG: [
    {
      id: 'bng-1',
      name: 'Coin Strike 2',
      provider: 'BNG',
      image: '/game-images/bng/coin-strike-2.png',
      maxWin: '3,500x',
      rtp: '96.10%',
    },
    {
      id: 'bng-2',
      name: 'Coin Volcano 2',
      provider: 'BNG',
      image: '/game-images/bng/coin-volcano-2.png',
      maxWin: '4,000x',
      rtp: '96.05%',
    },
    {
      id: 'bng-3',
      name: 'Royal Express',
      provider: 'BNG',
      image: '/game-images/bng/royal-express.png',
      maxWin: '2,500x',
      rtp: '95.95%',
    },
    {
      id: 'bng-4',
      name: 'Hawaii Riches',
      provider: 'BNG',
      image: '/game-images/bng/hawaii-riches.png',
      maxWin: '3,000x',
      rtp: '96.20%',
    },
    {
      id: 'bng-5',
      name: 'Energy Joker',
      provider: 'BNG',
      image: '/game-images/bng/energy-joker.png',
      maxWin: '5,000x',
      rtp: '96.00%',
    },
    {
      id: 'bng-6',
      name: '3 Pirate Barrels',
      provider: 'BNG',
      image: '/game-images/bng/3-pirate-barrels.png',
      maxWin: '3,200x',
      rtp: '96.15%',
    },
    {
      id: 'bng-7',
      name: 'Super Hot Chilli',
      provider: 'BNG',
      image: '/game-images/bng/super-hot-chilli.png',
      maxWin: '2,800x',
      rtp: '95.90%',
    },
    {
      id: 'bng-8',
      name: 'Thunder Coins XXL',
      provider: 'BNG',
      image: '/game-images/bng/thunder-coins-xxl.png',
      maxWin: '6,000x',
      rtp: '96.30%',
    },
    {
      id: 'bng-9',
      name: 'Pink Joker',
      provider: 'BNG',
      image: '/game-images/bng/pink-joker.png',
      maxWin: '2,200x',
      rtp: '95.85%',
    },
    {
      id: 'bng-10',
      name: 'Sherwood Coins',
      provider: 'BNG',
      image: '/game-images/bng/sherwood-coins.png',
      maxWin: '3,400x',
      rtp: '96.00%',
    },
    {
      id: 'bng-11',
      name: 'Fire Coins',
      provider: 'BNG',
      image: '/game-images/bng/fire-coins.png',
      maxWin: '3,700x',
      rtp: '96.10%',
    },
    {
      id: 'bng-12',
      name: 'Fire Temple',
      provider: 'BNG',
      image: '/game-images/bng/fire-temple.png',
      maxWin: '4,200x',
      rtp: '96.25%',
    },
    {
      id: 'bng-13',
      name: 'Coin Strike',
      provider: 'BNG',
      image: '/game-images/bng/coin-strike.png',
      maxWin: '3,300x',
      rtp: '96.00%',
    },
    {
      id: 'bng-14',
      name: 'Forest Spirit',
      provider: 'BNG',
      image: '/game-images/bng/forest-spirit.png',
      maxWin: '2,900x',
      rtp: '95.80%',
    },
    {
      id: 'bng-15',
      name: 'Grab The Gold',
      provider: 'BNG',
      image: '/game-images/bng/grab-the-gold.png',
      maxWin: '4,500x',
      rtp: '96.35%',
    },
    {
      id: 'bng-16',
      name: 'Aztec Fire 2',
      provider: 'BNG',
      image: '/game-images/bng/aztec-fire-2.png',
      maxWin: '5,500x',
      rtp: '96.40%',
    },
  ],
  CQ9: [
    { id: 'cq9-1', name: 'Money Tree', provider: 'CQ9', image: '/game-images/cq9/money-tree.png', maxWin: '3,500x', rtp: '96.10%' },
    { id: 'cq9-2', name: 'Treasure Pirate', provider: 'CQ9', image: '/game-images/cq9/treasure-pirate.png', maxWin: '4,200x', rtp: '96.05%' },
    { id: 'cq9-3', name: 'Disco Night', provider: 'CQ9', image: '/game-images/cq9/disco-night.png', maxWin: '3,800x', rtp: '95.98%' },
    { id: 'cq9-4', name: "Move N' Jump", provider: 'CQ9', image: '/game-images/cq9/move-n-jump.png', maxWin: '4,500x', rtp: '96.15%' },
    { id: 'cq9-5', name: 'Fortune Totem', provider: 'CQ9', image: '/game-images/cq9/fortune-totem.png', maxWin: '5,000x', rtp: '96.20%' },
    { id: 'cq9-6', name: 'Dragon Ball', provider: 'CQ9', image: '/game-images/cq9/dragon-ball.png', maxWin: '6,000x', rtp: '96.08%' },
    { id: 'cq9-7', name: 'Good Fortune', provider: 'CQ9', image: '/game-images/cq9/good-fortune.png', maxWin: '3,200x', rtp: '95.90%' },
    { id: 'cq9-8', name: 'SkrSkr', provider: 'CQ9', image: '/game-images/cq9/skrskr.png', maxWin: '4,800x', rtp: '96.12%' },
    { id: 'cq9-9', name: 'Fa Cai Shen 2', provider: 'CQ9', image: '/game-images/cq9/fa-cai-shen-2.png', maxWin: '5,500x', rtp: '96.25%' },
    { id: 'cq9-10', name: 'Zeus', provider: 'CQ9', image: '/game-images/cq9/zeus.png', maxWin: '7,500x', rtp: '96.12%' },
    { id: 'cq9-11', name: 'Rave Jump', provider: 'CQ9', image: '/game-images/cq9/rave-jump.png', maxWin: '4,000x', rtp: '96.00%' },
    { id: 'cq9-12', name: 'Invincible Elephant', provider: 'CQ9', image: '/game-images/cq9/invincible-elephant.png', maxWin: '5,200x', rtp: '96.18%' },
    { id: 'cq9-13', name: 'Fruity Carnival', provider: 'CQ9', image: '/game-images/cq9/fruity-carnival.png', maxWin: '3,600x', rtp: '95.95%' },
    { id: 'cq9-14', name: 'Treasure Island', provider: 'CQ9', image: '/game-images/cq9/treasure-island.png', maxWin: '4,600x', rtp: '96.10%' },
    { id: 'cq9-15', name: 'Football Baby', provider: 'CQ9', image: '/game-images/cq9/football-baby.png', maxWin: '3,400x', rtp: '95.88%' },
  ],
  JILI: [
    {
      id: 'jili-1',
      name: 'Zeus',
      provider: 'JILI',
      image: '/game-images/jili/zeus.png',
      maxWin: '7,500x',
      rtp: '96.12%',
    },
    {
      id: 'jili-2',
      name: 'Golden Empire 2',
      provider: 'JILI',
      image: '/game-images/jili/golden-empire-2.png',
      maxWin: '8,000x',
      rtp: '96.08%',
    },
    {
      id: 'jili-3',
      name: 'Super Ace Deluxe',
      provider: 'JILI',
      image: '/game-images/jili/super-ace-deluxe.png',
      maxWin: '5,000x',
      rtp: '96.20%',
    },
    {
      id: 'jili-4',
      name: 'Lucky Jaguar',
      provider: 'JILI',
      image: '/game-images/jili/lucky-jaguar.png',
      maxWin: '4,500x',
      rtp: '95.98%',
    },
    {
      id: 'jili-5',
      name: 'Fruity Wheel',
      provider: 'JILI',
      image: '/game-images/jili/fruity-wheel.png',
      maxWin: '3,200x',
      rtp: '96.05%',
    },
    {
      id: 'jili-6',
      name: 'Money Pot Deluxe',
      provider: 'JILI',
      image: '/game-images/jili/money-pot-deluxe.png',
      maxWin: '6,000x',
      rtp: '96.00%',
    },
    {
      id: 'jili-7',
      name: 'Neko Fortune',
      provider: 'JILI',
      image: '/game-images/jili/neko-fortune.png',
      maxWin: '4,800x',
      rtp: '96.15%',
    },
    {
      id: 'jili-8',
      name: 'Pirate Queen 2',
      provider: 'JILI',
      image: '/game-images/jili/pirate-queen-2.png',
      maxWin: '9,000x',
      rtp: '96.04%',
    },
    {
      id: 'jili-9',
      name: 'Coin Tree',
      provider: 'JILI',
      image: '/game-images/jili/coin-tree.png',
      maxWin: '3,000x',
      rtp: '95.92%',
    },
    {
      id: 'jili-10',
      name: 'Devil Fire 2',
      provider: 'JILI',
      image: '/game-images/jili/devil-fire-2.png',
      maxWin: '7,200x',
      rtp: '96.11%',
    },
    {
      id: 'jili-11',
      name: 'Poseidon',
      provider: 'JILI',
      image: '/game-images/jili/poseidon.png',
      maxWin: '5,600x',
      rtp: '96.07%',
    },
    {
      id: 'jili-12',
      name: '3 Pot Dragons',
      provider: 'JILI',
      image: '/game-images/jili/3-pot-dragons.png',
      maxWin: '6,800x',
      rtp: '96.18%',
    },
  ],
  Joker: [
    { id: 'joker-1', name: 'Super Fortune Crown', provider: 'Joker', image: '/game-images/joker/super-fortune-crown.png', maxWin: '5,500x', rtp: '96.20%' },
    { id: 'joker-2', name: 'Gates of Wealth', provider: 'Joker', image: '/game-images/joker/gates-of-wealth.png', maxWin: '4,800x', rtp: '96.15%' },
    { id: 'joker-3', name: 'Masquerade', provider: 'Joker', image: '/game-images/joker/masquerade.png', maxWin: '4,200x', rtp: '96.08%' },
    { id: 'joker-4', name: 'Leprechaun', provider: 'Joker', image: '/game-images/joker/leprechaun.png', maxWin: '3,800x', rtp: '95.95%' },
    { id: 'joker-5', name: 'Lion Of The East', provider: 'Joker', image: '/game-images/joker/lion-of-the-east.png', maxWin: '5,200x', rtp: '96.25%' },
    { id: 'joker-6', name: 'Azteca', provider: 'Joker', image: '/game-images/joker/azteca.png', maxWin: '4,500x', rtp: '96.10%' },
    { id: 'joker-7', name: 'Dragon of the Eastern Sea', provider: 'Joker', image: '/game-images/joker/dragon-of-the-eastern-sea.png', maxWin: '6,000x', rtp: '96.18%' },
    { id: 'joker-8', name: 'Buccaneer Deluxe', provider: 'Joker', image: '/game-images/joker/buccaneer-deluxe.png', maxWin: '5,000x', rtp: '96.12%' },
    { id: 'joker-9', name: 'Chinese Boss', provider: 'Joker', image: '/game-images/joker/chinese-boss.png', maxWin: '4,600x', rtp: '96.05%' },
    { id: 'joker-10', name: 'BeachLife', provider: 'Joker', image: '/game-images/joker/beachlife.png', maxWin: '3,600x', rtp: '95.90%' },
    { id: 'joker-11', name: 'Wealth God', provider: 'Joker', image: '/game-images/joker/wealth-god.png', maxWin: '5,800x', rtp: '96.22%' },
    { id: 'joker-12', name: "Dolphin's Pearl Deluxe", provider: 'Joker', image: '/game-images/joker/dolphins-pearl-deluxe.png', maxWin: '4,000x', rtp: '96.00%' },
  ],
  JDB: [
    { id: 'jdb-1', name: 'Lucky 777', provider: 'JDB', image: '/game-images/jdb/lucky-777.png', maxWin: '12,000x', rtp: '97.30%' },
    { id: 'jdb-2', name: 'Golden Disco', provider: 'JDB', image: '/game-images/jdb/golden-disco.png', maxWin: '9,500x', rtp: '96.35%' },
    { id: 'jdb-3', name: 'Dragons Gate', provider: 'JDB', image: '/game-images/jdb/dragons-gate.png', maxWin: '8,000x', rtp: '96.20%' },
    { id: 'jdb-4', name: 'Open Sesame II', provider: 'JDB', image: '/game-images/jdb/open-sesame-ii.png', maxWin: '7,500x', rtp: '96.10%' },
    { id: 'jdb-5', name: 'Winning Mask II', provider: 'JDB', image: '/game-images/jdb/winning-mask-ii.png', maxWin: '6,000x', rtp: '96.05%' },
    { id: 'jdb-6', name: 'Wonder Elephant', provider: 'JDB', image: '/game-images/jdb/wonder-elephant.png', maxWin: '5,500x', rtp: '95.98%' },
    { id: 'jdb-7', name: 'Blossom of Wealth', provider: 'JDB', image: '/game-images/jdb/blossom-of-wealth.png', maxWin: '5,000x', rtp: '96.15%' },
    { id: 'jdb-8', name: 'Moneybags Man 2', provider: 'JDB', image: '/game-images/jdb/moneybags-man-2.png', maxWin: '4,800x', rtp: '96.08%' },
    { id: 'jdb-9', name: 'Double Wilds', provider: 'JDB', image: '/game-images/jdb/double-wilds.png', maxWin: '4,200x', rtp: '95.92%' },
    { id: 'jdb-10', name: 'Birds Party Deluxe', provider: 'JDB', image: '/game-images/jdb/birds-party-deluxe.png', maxWin: '3,800x', rtp: '96.00%' },
  ],
  'Rich Gaming': [
    { id: 'rich-1', name: '777 Steampunk', provider: 'Rich Gaming', image: '/game-images/rich-gaming/777-steampunk.png', maxWin: '5,000x', rtp: '96.10%' },
    { id: 'rich-2', name: 'Bank Fever', provider: 'Rich Gaming', image: '/game-images/rich-gaming/bank-fever.png', maxWin: '4,500x', rtp: '96.05%' },
    { id: 'rich-3', name: 'Buffalo Superways', provider: 'Rich Gaming', image: '/game-images/rich-gaming/buffalo-superways.png', maxWin: '6,000x', rtp: '96.15%' },
    { id: 'rich-4', name: 'Dance Dance Lion', provider: 'Rich Gaming', image: '/game-images/rich-gaming/dance-dance-lion.png', maxWin: '4,200x', rtp: '95.98%' },
    { id: 'rich-5', name: 'Aztec Holiday', provider: 'Rich Gaming', image: '/game-images/rich-gaming/aztec-holiday.png', maxWin: '4,800x', rtp: '96.12%' },
    { id: 'rich-6', name: 'Rex Rampage', provider: 'Rich Gaming', image: '/game-images/rich-gaming/rex-rampage.png', maxWin: '5,500x', rtp: '96.20%' },
    { id: 'rich-7', name: 'Ace High Ace', provider: 'Rich Gaming', image: '/game-images/rich-gaming/ace-high-ace.png', maxWin: '3,800x', rtp: '96.00%' },
    { id: 'rich-8', name: 'Bank Mania', provider: 'Rich Gaming', image: '/game-images/rich-gaming/bank-mania.png', maxWin: '4,600x', rtp: '96.08%' },
    { id: 'rich-9', name: 'BBQ Delight', provider: 'Rich Gaming', image: '/game-images/rich-gaming/bbq-delight.png', maxWin: '3,500x', rtp: '95.92%' },
    { id: 'rich-10', name: 'Mafia Empire', provider: 'Rich Gaming', image: '/game-images/rich-gaming/mafia-empire.png', maxWin: '5,200x', rtp: '96.18%' },
    { id: 'rich-11', name: 'Misty Witch', provider: 'Rich Gaming', image: '/game-images/rich-gaming/misty-witch.png', maxWin: '4,400x', rtp: '96.10%' },
    { id: 'rich-12', name: 'Cai Shen Coin', provider: 'Rich Gaming', image: '/game-images/rich-gaming/cai-shen-coin.png', maxWin: '5,800x', rtp: '96.25%' },
    { id: 'rich-13', name: 'Magic Genie', provider: 'Rich Gaming', image: '/game-images/rich-gaming/magic-genie.png', maxWin: '4,000x', rtp: '96.02%' },
    { id: 'rich-14', name: 'Space Crystals', provider: 'Rich Gaming', image: '/game-images/rich-gaming/space-crystals.png', maxWin: '5,400x', rtp: '96.15%' },
  ],
  'Pragmatic Play': [
    { id: 'pragmatic-1', name: 'Gates of Olympus', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/gates-of-olympus.png', maxWin: '5,000x', rtp: '96.50%' },
    { id: 'pragmatic-2', name: 'Sweet Bonanza', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/sweet-bonanza.png', maxWin: '21,100x', rtp: '96.48%' },
    { id: 'pragmatic-3', name: 'Starlight Princess', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/starlight-princess.png', maxWin: '5,000x', rtp: '96.50%' },
    { id: 'pragmatic-4', name: 'Sugar Rush', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/sugar-rush.png', maxWin: '5,000x', rtp: '96.50%' },
    { id: 'pragmatic-5', name: 'Bonanza Gold', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/bonanza-gold.png', maxWin: '10,000x', rtp: '96.52%' },
    { id: 'pragmatic-6', name: 'Aztec Gems', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/aztec-gems.png', maxWin: '225x', rtp: '96.52%' },
    { id: 'pragmatic-7', name: 'Wild West Gold', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/wild-west-gold.png', maxWin: '10,000x', rtp: '96.51%' },
    { id: 'pragmatic-8', name: 'Gates of Gatot Kaca', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/gates-of-gatot-kaca.png', maxWin: '5,000x', rtp: '96.50%' },
    { id: 'pragmatic-9', name: '5 Lions Megaways', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/5-lions-megaways.png', maxWin: '20,000x', rtp: '96.56%' },
    { id: 'pragmatic-10', name: 'Wisdom of Athena', provider: 'Pragmatic Play', image: '/game-images/pragmatic-play/wisdom-of-athena.png', maxWin: '5,000x', rtp: '96.50%' },
  ],
  Microgaming: [
    { id: 'microgaming-1', name: 'Fortunium', provider: 'Microgaming', image: '/game-images/microgaming/fortunium.png', maxWin: '10,000x', rtp: '96.09%' },
    { id: 'microgaming-2', name: 'Kings of Cash', provider: 'Microgaming', image: '/game-images/microgaming/kings-of-cash.png', maxWin: '20,000x', rtp: '96.25%' },
    { id: 'microgaming-3', name: 'Book of Oz Lock N Spin', provider: 'Microgaming', image: '/game-images/microgaming/book-of-oz-lock-n-spin.png', maxWin: '5,000x', rtp: '96.12%' },
    { id: 'microgaming-4', name: '9 Masks of Fire Hyper Spins', provider: 'Microgaming', image: '/game-images/microgaming/9-masks-of-fire-hyper-spins.png', maxWin: '20,000x', rtp: '96.08%' },
    { id: 'microgaming-5', name: 'Chronicles of Olympus X-Up', provider: 'Microgaming', image: '/game-images/microgaming/chronicles-of-olympus-x-up.png', maxWin: '10,000x', rtp: '96.15%' },
    { id: 'microgaming-6', name: 'Eagles Wings', provider: 'Microgaming', image: '/game-images/microgaming/eagles-wings.png', maxWin: '4,000x', rtp: '96.10%' },
    { id: 'microgaming-7', name: 'Lucky Koi', provider: 'Microgaming', image: '/game-images/microgaming/lucky-koi.png', maxWin: '8,000x', rtp: '96.05%' },
    { id: 'microgaming-8', name: 'Wild Catch', provider: 'Microgaming', image: '/game-images/microgaming/wild-catch.png', maxWin: '5,000x', rtp: '95.98%' },
    { id: 'microgaming-9', name: '5 Star Knockout', provider: 'Microgaming', image: '/game-images/microgaming/5-star-knockout.png', maxWin: '2,500x', rtp: '96.00%' },
    { id: 'microgaming-10', name: 'Doki Doki Parfait', provider: 'Microgaming', image: '/game-images/microgaming/doki-doki-parfait.png', maxWin: '3,000x', rtp: '96.12%' },
  ],
};

const expertTopPick = {
  id: 'expert-fixed',
  name: 'Gates of Olympus',
  provider: 'Pragmatic Play',
  image: '/game-images/gates-of-olympus.png',
  rtp: '98.24%',
};

const TOP10_MAX_WIN_OPTIONS = ['20,000x', '25,000x', '30,000x', '50,000x'];

function pickRandomFromArray<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function buildTopTenGames(): FreeGameItem[] {
  const randomRtp = () => {
    const value = 97 + Math.random() * (98.89 - 97);
    return `${value.toFixed(2)}%`;
  };

  const jiliGames = [...providerGameLibrary.JILI];
  const shuffled = jiliGames.sort(() => Math.random() - 0.5);
  const selected = shuffled.slice(0, 10);

  return selected.map((game, idx) => ({
    ...game,
    id: `top-${idx + 1}`,
    maxWin: pickRandomFromArray(TOP10_MAX_WIN_OPTIONS),
    rtp: randomRtp(),
  }));
}

const playerReviews = [
  { name: 'Alex M.', rating: 5, comment: 'Zeus hit really often in demo mode. Smooth gameplay and fast loading.' },
  { name: 'Chloe T.', rating: 4, comment: 'Pirate Queen 2 is still my favorite. Volatile, but very fun to test.' },
  { name: 'Ryan K.', rating: 5, comment: 'Devil Fire 2 has insane win potential. Great for players who like risk.' },
  { name: 'Mia L.', rating: 4, comment: 'Golden Empire 2 is beginner-friendly and the bonus feature is exciting.' },
  { name: 'Jay P.', rating: 4, comment: 'Super Ace Deluxe feels clean and strategic. Nice RTP for practice.' },
];

const DEFAULT_GAMES_SHOWN = 15;

export default function FreeGames() {
  const [selectedProvider, setSelectedProvider] = useState<'All Providers' | ProviderName>('All Providers');
  const [searchQuery, setSearchQuery] = useState('');
  const [showAllGames, setShowAllGames] = useState(false);

  const providerGames = useMemo(() => {
    if (selectedProvider === 'All Providers') {
      return Object.values(providerGameLibrary).flat();
    }
    return providerGameLibrary[selectedProvider] ?? [];
  }, [selectedProvider]);

  const featuredGames = useMemo(() => {
    return providerGames.filter((game) => {
      const searchMatch =
        searchQuery.trim() === '' ||
        game.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        game.provider.toLowerCase().includes(searchQuery.toLowerCase());
      return searchMatch;
    });
  }, [providerGames, searchQuery]);

  const visibleFeaturedGames = useMemo(() => {
    if (selectedProvider === 'All Providers' && !showAllGames) {
      return featuredGames.slice(0, DEFAULT_GAMES_SHOWN);
    }
    return featuredGames;
  }, [featuredGames, selectedProvider, showAllGames]);

  const hasMoreGames = selectedProvider === 'All Providers' && featuredGames.length > DEFAULT_GAMES_SHOWN && !showAllGames;

  const topTenGames = useMemo(() => buildTopTenGames(), []);

  const handlePlayClick = (game?: any) => {
    if (game?.category === 'Live Casino' && game?.provider) {
      openPlayLinkByBrand(game.provider);
    } else {
      openRandomPlayLink();
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f5f7]">
      <Navbar />

      <section className="relative bg-gradient-to-r from-[#3216a8] via-[#4522cc] to-[#6a32f0] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-25">
          <div className="absolute -left-20 -top-20 w-72 h-72 rounded-full bg-white/20 blur-3xl"></div>
          <div className="absolute right-0 top-0 w-72 h-72 rounded-full bg-[#ffb347]/20 blur-3xl"></div>
          <div className="absolute left-1/2 -translate-x-1/2 bottom-0 w-96 h-40 bg-white/10 blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-10 pb-7">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center leading-tight">
            Play 13,000+ free casino games
            <br />
            <span className="text-purple-100">(sign-up now get Bonuses)</span>
          </h1>

          <div className="mt-10 flex items-stretch justify-center">
            <div className="w-full md:w-[640px] relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search for your favorite game..."
                className="w-full h-12 rounded-lg bg-white text-gray-900 pl-11 pr-4 outline-none ring-0"
              />
            </div>
          </div>

          <div className="mt-10 overflow-x-auto pb-1">
            <div className="w-max min-w-full flex items-center justify-start sm:justify-center gap-2.5">
              {providerOptions.map((provider) => (
                <button
                  key={provider.value}
                  onClick={() => {
                    setSelectedProvider(provider.value);
                    if (provider.value === 'All Providers') setShowAllGames(false);
                  }}
                  className={`h-14 px-3 rounded-xl border bg-white flex items-center justify-center transition-colors ${
                    selectedProvider === provider.value
                      ? 'border-purple-600 ring-1 ring-purple-500'
                      : 'border-gray-200 hover:border-purple-300'
                  } ${provider.logo ? 'w-[126px]' : 'w-[82px]'}`}
                >
                  {provider.logo ? (
                    <img
                      src={provider.logo}
                      alt={provider.label}
                      className="max-h-8 w-auto max-w-[100px] object-contain"
                    />
                  ) : (
                    <span className="text-sm font-semibold text-gray-700">{provider.label}</span>
                  )}
                </button>
              ))}
            </div>
          </div>

        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-5">Most popular games in the month</h2>
        <div className="space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {visibleFeaturedGames.map((game, index) => (
            <div
              key={game.id}
              className="group relative rounded-2xl overflow-hidden bg-white border border-gray-200 hover:border-purple-300 hover:shadow-lg transition-all duration-200"
            >
              <span className="absolute left-3 top-2 text-6xl font-extrabold text-[#6f53ff]/15 z-10">{index + 1}</span>
              <div className="relative">
                {['Rich Gaming', 'CQ9', 'JDB', 'Pragmatic Play', 'Microgaming'].includes(game.provider) ? (
                  <div className="h-40 w-full flex items-center justify-center bg-gray-50 p-3">
                    <img src={game.image} alt={game.name} className="h-full w-auto max-w-full object-contain" />
                  </div>
                ) : (
                  <img src={game.image} alt={game.name} className="h-40 w-full object-cover" />
                )}
                <div className="absolute inset-0 bg-black/50 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <button
                    onClick={() => handlePlayClick(game)}
                    className="px-5 py-2.5 min-h-[44px] rounded-lg bg-[#e15a00] hover:bg-[#c44f00] text-white font-bold text-sm transition-colors"
                  >
                    Play Now
                  </button>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-purple-700 font-semibold mb-1">{game.provider}</p>
                <h3 className="text-base font-bold text-gray-900 leading-snug">{game.name}</h3>
              </div>
            </div>
          ))}
        </div>
        {hasMoreGames && (
          <div className="flex justify-center pt-2">
            <button
              onClick={() => setShowAllGames(true)}
              className="px-8 py-3 min-h-[44px] rounded-xl bg-[#3d12c8] hover:bg-[#320ea8] text-white font-semibold transition-colors"
            >
              Load More Games
            </button>
          </div>
        )}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-8">
        <div className="rounded-xl border border-gray-300 bg-white p-5 md:p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
            <img
              src={expertTopPick.image}
              alt={expertTopPick.name}
              className="w-full h-auto object-contain rounded-xl border border-gray-200"
            />

            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1.5">Expert&apos;s top pick - {expertTopPick.name}</h3>

              <p className="mt-4 text-sm text-gray-700 mb-4 leading-relaxed">
                Land 8-30 matching symbols anywhere on the tumbling reels to win up to 50x, boosted even further by random multiplier symbols with values up to 500x.
              </p>
              <p className="text-sm text-gray-700 mb-5 leading-relaxed">
                4+ scatter symbols trigger the bonus game with 15 free spins. Whenever a multiplier symbol lands on a winning spin, it&apos;s added to a total running multiplier and applied to that win.
              </p>

              <h4 className="text-sm font-bold text-gray-900 mb-2">What to expect:</h4>
              <ul className="space-y-2 mb-5 text-sm text-gray-800">
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-[#4f2dfd] bg-[#f1edff] rounded-full p-1 flex-shrink-0"></i>
                  <span>Symbols pay anywhere on the screen across six tumbling reels</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-[#4f2dfd] bg-[#f1edff] rounded-full p-1 flex-shrink-0"></i>
                  <span>Multiplier symbols with values up to 500x can land in the base game and free spins</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-[#4f2dfd] bg-[#f1edff] rounded-full p-1 flex-shrink-0"></i>
                  <span>During the feature, winning multiplier symbols are added to a total multiplier which is applied to that respective win</span>
                </li>
              </ul>

              <h4 className="text-sm font-bold text-gray-900 mb-2">Basic Game Info</h4>
              <p className="text-sm text-gray-700 mb-6">
                RTP: {expertTopPick.rtp}
              </p>

              <button
                onClick={handlePlayClick}
                className="inline-flex items-center justify-center px-6 h-11 rounded-lg bg-[#e15a00] hover:bg-[#c44f00] text-white text-sm font-bold transition-colors"
              >
                Play Now
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-16">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Top 10 free casino games for 2026</h2>
        <p className="text-base leading-relaxed text-gray-700 mb-7 max-w-5xl">
          Every month, our team of experts spend 60+ hours testing games from JILI provider
          to decide which are the best. We assess payout rates, volatility, feature depth,
          rules, side bets, load times, mobile optimisation, and how smoothly each game runs in real play.
          Discover our top 10 casino games and play them for free in demo mode right here.
        </p>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 items-start">
          <div className="xl:col-span-2 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5">
            {topTenGames.map((game) => (
              <article key={game.id} className="rounded-xl border border-gray-300 bg-white overflow-hidden">
                <div className="w-full bg-gray-50">
                  <img src={game.image} alt={game.name} className="block w-full h-auto" />
                </div>

                <div className="p-4">
                  <button
                    onClick={handlePlayClick}
                    className="w-full h-11 rounded-lg bg-[#3d12c8] hover:bg-[#320ea8] text-white text-sm font-semibold transition-colors"
                  >
                    Play Now
                  </button>
                  <h3 className="mt-3 text-xl font-bold text-gray-900 leading-tight">{game.name}</h3>
                  <p className="mt-2 text-sm text-gray-700 leading-relaxed">
                    {game.provider} | Max win {game.maxWin} | RTP {game.rtp}
                  </p>
                </div>
              </article>
            ))}
          </div>

          <aside className="xl:sticky xl:top-24 space-y-4">
            <section className="rounded-xl border border-gray-300 bg-white p-4">
              <h3 className="text-base font-bold text-gray-900 mb-3">Games Popularity</h3>
              <div className="space-y-3">
                {topTenGames.map((game, idx) => {
                  const score = 95 - idx * 3;
                  return (
                    <div key={game.id}>
                      <div className="flex items-center justify-between mb-1.5">
                        <span className="text-sm font-medium text-gray-700 truncate pr-2">{game.name}</span>
                        <span className="text-xs font-semibold text-gray-600">{score}%</span>
                      </div>
                      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-purple-500 to-indigo-500 rounded-full"
                          style={{ width: `${score}%` }}
                        ></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>

            <section className="rounded-xl border border-gray-300 bg-white p-4">
              <h3 className="text-base font-bold text-gray-900 mb-3">Players Right Now</h3>
              <div className="space-y-2.5">
                {topTenGames.map((game, idx) => {
                  const players = 1280 - idx * 85;
                  return (
                    <div key={game.id} className="flex items-center justify-between text-sm">
                      <span className="text-gray-700 truncate pr-2">{game.name}</span>
                      <span className="font-semibold text-gray-900">{players.toLocaleString()}</span>
                    </div>
                  );
                })}
              </div>
            </section>

            <section className="rounded-xl border border-gray-300 bg-white p-4">
              <h3 className="text-base font-bold text-gray-900 mb-3">Player Reviews</h3>
              <div className="space-y-3">
                {playerReviews.map((review) => (
                  <div key={review.name} className="pb-3 border-b border-gray-100 last:border-b-0 last:pb-0">
                    <div className="flex items-center justify-between mb-1">
                      <p className="text-sm font-semibold text-gray-900">{review.name}</p>
                      <div className="flex items-center gap-0.5 text-yellow-500">
                        {[...Array(review.rating)].map((_, i) => (
                          <i key={i} className="ri-star-fill text-xs"></i>
                        ))}
                      </div>
                    </div>
                    <p className="text-xs text-gray-600 leading-relaxed">{review.comment}</p>
                  </div>
                ))}
              </div>
            </section>
          </aside>
        </div>
      </section>

      <Footer />
    </div>
  );
}
